<!--SWITCH BUTTON-->
<!--NOTE: The switch button is really a checkbox html element with different syling-->
<div class="toggle-nav">
  <!--NOTE: By default the left label is styled in orange to indicate the current state. It will update the left or right label based on the toggle state-->
  <span
    [ngClass]="!toggleSwitch ? 'toggleSelectedOnState' : 'toggleSelectedOffState'"
    class="small-text margin-left-large margin-right-small">
    {{ offStateLabel }}
  </span>
  <!--NOTE: Label is required for siwtch checkbox for accessiblity-->
  <label class="switch" for="{{ id }}">
    <input
      title="Toggle switch between {{ offStateLabel }} and {{ onStateLabel }}"
      id="{{ id }}"
      type="checkbox"
      (click)="onToggleChange()"
      [(ngModel)]="toggleSwitch" />
    <span class="slider round cursor"></span>
  </label>
  <span
    [ngClass]="toggleSwitch ? 'toggleSelectedOnState' : 'toggleSelectedOffState'"
    class="small-text margin-right-large margin-left-small">
    {{ onStateLabel }}
  </span>
</div>
<!--END SWITCH BUTTON-->
